export const categories = [
  {
    id: "tablettes",
    title: "Nos Tablettes",
    image: "/images/categories/tablettes_cat.png",
    link: "/categories/tablettes",
  },
  {
    id: "mendiants",
    title: "Nos Mendiants",
    image: "/images/categories/mendiants.jpg",
    link: "/categories/mendiants",
  },
  {
    id: "cafes",
    title: "Cafés Gourmands",
    image: "/images/categories/cafe_gourmand_cat1.png",
    link: "/categories/cafes-gourmands",
  },
  {
    id: "fleurs",
    title: "Nos Créations Florales",
    image: "/images/categories/evenement_cat.jpg",
    link: "/categories/creations-florales",
  },
  {
    id: "evenements",
    title: "Vos Événements",
    image: "/images/categories/photo_2026-04-16_13-10-51.jpg",
    link: "/categories/evenements",
  },
  {
    id: "box-decouverte",
    title: "Box Découverte",
    image: "/images/categories/box_decouverte_cat.jpg",
    link: "/categories/box-decouverte",
  },
  {
    id: "coeurs",
    title: "Cœurs en Chocolat",
    image: "/images/categories/coeurs_cat.jpg",
    link: "/categories/coeurs-chocolat",
  },
  {
    id: "fraises",
    title: "Fraises Enrobées",
    image: "/images/categories/fraises_cat.jpg",
    link: "/categories/fraises-enrobees",
  },
  {
    id: "carres-orient",
    title: "Carrés d'Orient",
    image: "/images/categories/carres_orient_cat.jpg",
    link: "/categories/carres-orient",
  },
    {
    id: "ecrin-douceur",
    title: "L'Écrin Douceur",
    image: "/images/categories/ecrin_douceur_cat.jpg",
    link: "/categories/ecrin-douceur",
  },
];